<template>
  <v-app class="app">
    <v-main v-if="(desktop && !from) || isExceptedRoute">
      <!-- Top Swiset Pro CTA !-->
      <TopProCTA v-if="
        this.upgradeExceptionRoutes.indexOf($route.name) === -1 &&
        !this.$store.state.user.isPro &&
        !isEmbedded &&
        this.$store.state.token &&
        !isTDP &&
        !isRegistrationFlow
      " />
      <!-- Main App Views !-->
      <TopNavbar v-if="
        isEmbedded &&
        this.outOfAppExceptionRoutes.indexOf($route.name) === -1 &&
        !isTDP
      " />
      
      <v-row :style="!isEmbedded && this.fullHeightRoutes.indexOf($route.name) === -1
        ? ''
        : 'height: 100% !important;'
        ">
        <!-- Navbar Column - Adjusted for responsive layout -->
        <v-col v-if="shouldShowNavbar" 
          :cols="deviceSize.isMobile ? '12' : '1'"
          :class="{'p-0': deviceSize.isMobile}"
        >
          <Navbar class="mr-n10" />
        </v-col>
        
        <!-- Content Column - Adjusted for responsive layout -->
        <v-col 
          :class="shouldShowNavbar && !deviceSize.isMobile ? 'ml-n10 pr-1' : 'pa-0'"
          :cols="shouldShowNavbar && !deviceSize.isMobile ? '11' : '12'"
          :style="deviceSize.isMobile ? 'padding-bottom: 60px;' : ''"
        >
          <v-spacer v-if="isEmbedded && !isTDP" class="my-10" />
          <RouterView :isTDP="isTDP" :class="isEmbedded ? 'px-10' : ''" />
        </v-col>
      </v-row>

      <!-- Help & Support Components !-->
      <HelpDesk v-if="this.$store.state.token && !isRegistrationFlow" :help="helpDesk" @close="helpDesk = false" />
      <v-btn v-if="
        this.upgradeExceptionRoutes.indexOf($route.name) === -1 &&
        this.$store.state.token &&
        !isEmbedded &&
        !isTDP &&
        !isRegistrationFlow && 
        !deviceSize.isMobile
      " :class="$store.state.user.isPro ? 'help-button-for-pro' : 'help-button-no-pro'"
        @click="helpDesk = !helpDesk" top right small>
        {{ $t('btnHelp') }}
        <v-icon class="ml-2" x-small>fa-regular fa-question</v-icon>
      </v-btn>
      
      <!-- Mobile Help Button (floating) -->
      <v-btn
        v-if="deviceSize.isMobile && 
          this.upgradeExceptionRoutes.indexOf($route.name) === -1 &&
          this.$store.state.token &&
          !isEmbedded &&
          !isTDP &&
          !isRegistrationFlow"
        fab
        small
        fixed
        bottom
        right
        color="mainGreen"
        class="mobile-help-btn"
        @click="helpDesk = !helpDesk"
      >
        <v-icon>fa-regular fa-question</v-icon>
      </v-btn>
    </v-main>
    <v-main v-else-if="!desktop && !from && !isExceptedRoute">
      <MobileNote />
    </v-main>
    <v-main v-if="from == 'verified'">
      <MagicLinkConfirmation />
    </v-main>

    <!-- Mobile language selector (only shown on mobile) -->
    <div 
      v-if="deviceSize.isMobile && 
        this.$store.state.token &&
        !isEmbedded"
      class="mobile-language-selector"
    >
      <LanguageSelector />
    </div>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import TopProCTA from "./components/TopProCTA.vue";
import axios from "axios";
import { mapMutations, mapActions } from "vuex";
import MobileNote from "./MobileNote";
import HelpDesk from "@/components/HelpDesk";
import TopNavbar from "@/components/TopNavbar.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import MagicLinkConfirmation from "./components/MagicLinkConfirmation.vue";
import WhitelabelRepository from "./repositories/whitelabel";
import LanguageSelector from './components/LanguageSelector.vue';

export default {
  name: "App",
  components: {
    PoweredBy,
    TopNavbar,
    HelpDesk,
    MobileNote,
    Navbar,
    TopProCTA,
    MagicLinkConfirmation,
    LanguageSelector,
  },
  data() {
    return {
      logged: false,
      isTDP: false,
      isMobile: false,
      fullHeightRoutes: ["login", "onboard"],
      upgradeExceptionRoutes: [
        "login",
        "subscription-plans",
        "welcome",
        "register-collapsed",
        "subscription-plans-collapsed",
        "confirmed-email",
        "reset-password",
        "basic-data",
        "confirmation",
        "sync-authorization",
        "sync-authorization-request",
        "tournament-embed-rank",
        "embed",
        "embed-introduction",
        "passwordless-checking",
        "embed-sso",
        "onboard",
      ],
      outOfAppExceptionRoutes: [
        "login",
        "welcome",
        "register-collapsed",
        "subscription-plans-collapsed",
        "basic-data",
        "reset-password",
        "confirmed-email",
        "sync-authorization",
        "sync-authorization-request",
        "tournament-embed-rank",
        "embed",
        "embed-introduction",
        "passwordless-checking",
        "embed-sso",
        "onboard",
      ],
      desktop: true,
      hydrated: false,
      helpDesk: false,
      exceptedRoutesByName: ["connectmt", "connectexness", "funding-simulation-summary", "funding-simulation-feedback", "tournament-overview", "tournament-embed-rank","tournament-embed-register"],
      deviceSize: {
        isMobile: false,
        isTablet: false,
        isDesktop: true
      }
    };
  },

  async created() {
    // Check device size initially
    this.checkDeviceSize();
    window.addEventListener("resize", this.checkDeviceSize);
    
    let firstLoad =
      this.$store.state.appThemes.dark == undefined ? true : false;
    await this.setupAppThemes();
    if (this.$store.state.whitelabel.partner == null) {
      let obj = {
        light: {
          baseBackground: "#F8F8F8",
          navBarBackground: "#061130",
          mainBtnBackground: "#C3FFE3",
          alternativeBtnBackground: "#dcdcdc",
          brandPrimary: "var(--v-darkGreen-base)",
          primary: "var(--v-darkGreen-base)",
          brandSecondary: "#061130",
          brandAccent: "#fff75f",
          warningAdvice: "#FF8933",
          mainWhite: "#F9F9F9",
          fullWhite: "#FFFFFF",
          mainBlack: "#000000",
          fullBlack: "#000000",
          darkGrey: "#4E4E4E",
          mediumGrey: "#EFEFEF",
          lightGrey: "#DCDCDC",
          darkGreen: "#247851",
          calmGreen: "#C3FFE3",
          darkRed: "#C42A14",
          calmRed: "#FFCAC2",
          darkBlue: "#1B5BFF",
          calmBlue: "#93C7FF",
          cardBackground: "#FFF",
          cardHeaderBackground: "#EEE",
          cardBackgroundForLogo: "#F9F9F9",
          progressBarBackground: "#EEEEEE",
          black_lightGrey: "#000000",
        },
        dark: {
          baseBackground: "#14161B",
          navBarBackground: "#DCDCDC",
          mainBtnBackground: "#247851",
          alternativeBtnBackground: "#4E4E4E",
          brandPrimary: "#0044A9",
          primary: "#C3FFE3",
          brandSecondary: "#061130",
          brandAccent: "#fff75f",
          warningAdvice: "#FF8933",
          mainWhite: "#1E1E1E",
          fullWhite: "#232830",
          mainBlack: "#F9F9F9",
          fullBlack: "#FFFFFF",
          darkGrey: "#DCDCDC",
          mediumGrey: "#EFEFEF",
          lightGrey: "#4E4E4E",
          darkGreen: "#C3FFE3",
          calmGreen: "#247851",
          darkRed: "#FFCAC2",
          calmRed: "#C42A14",
          darkBlue: "#93C7FF",
          calmBlue: "#1B5BFF",
          cardBackground: "#232830",
          cardHeaderBackground: "#4E5966",
          cardBackgroundForLogo: "#4E5966",
          progressBarBackground: "#303740",
          black_lightGrey: "#303740",
        },
      };
      this.updateAppThemes(obj);
    }

    let darkMode = new URLSearchParams(window.location.search).get("darkMode");
    if (darkMode == null || darkMode == undefined) {
      darkMode = localStorage.getItem("theme-preference") === "dark";
    }
    if (darkMode == false || darkMode == "false") {
      this.$vuetify.theme.dark = false;
      this.setCurrentTheme("light");
      localStorage.setItem("theme-preference", "light");
    } else if (darkMode || this.$store.state.currentTheme == "dark") {
      this.$vuetify.theme.dark = true;
      this.setCurrentTheme("dark");
      localStorage.setItem("theme-preference", "dark");
    }

    if (firstLoad) this.$router.go();

    if (this.$route.path == "/") {
      if (this.$store.state.token) {
        this.$router.push("/dashboard");
      }
    }
    if (this.$store.state.whitelabel.partner !== null)
      this.changePartnerName();
  },
  computed: {
    from() {
      return this.$route.query.from;
    },
    isEmbedded() {
      return this.$store.state.whitelabel.partner !== null;
    },
    showPowered() {
      // eslint-disable-next-line no-console
      if (
        this.$route.name != "onboard" &&
        !this.$route.name.includes("embed")
      ) {
        return (
          this.$store.state.whitelabel.features.findIndex(
            (feature) => feature.feature.name === "HIDE_POWERED_BY"
          ) === -1
        );
      }
      return false;
    },
    isExceptedRoute() {
      return this.exceptedRoutesByName.includes(this.$route.name);
    },
    isRegistrationFlow() {
      return ['welcome', 'confirmed-email', 'integrations', 'platform-setup'].includes(this.$route.name);
    },
    shouldShowNavbar() {
      return (!this.isEmbedded &&
        this.outOfAppExceptionRoutes.indexOf(this.$route.name) === -1 &&
        this.$store.state.token &&
        !this.isRegistrationFlow) ||
        (this.isTDP && this.outOfAppExceptionRoutes.indexOf(this.$route.name) === -1);
    }
  },
  provide() {
    return {
      isEmbedded: this.$store.state.whitelabel.partner !== null,
      isTDP: this.$store.state.whitelabel.apiKey === process.env.VUE_APP_EMBED_KEY,
      isMobile: window.innerWidth <= 768 ? true : false
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.helpDesk = false;
      if (this.$store.state.whitelabel.apiKey)
        this.changePartnerName();
      if (to.name == "login") {
        this.$router.go();
      }
    },
    "$store.state.user.isPro": function () {
      this.verifyPremiumChat();
    },
    "$store.state.preferredLanguage": function () {
      this.$root.$i18n.locale = this.$store.state.preferredLanguage;
    },
    "$vuetify.theme.themes": function () {
      this.$router.go();
    },
    "$store.state.whitelabel.apiKey": function () {
      this.isTDP =
        this.$store.state.whitelabel.apiKey == process.env.VUE_APP_EMBED_KEY;
    },
    "window": function () {
      this.isMobile = window.innerWidth <= 768 ? true : false
    }
  },
  async mounted() {
    document.addEventListener("click", function (e) {
      if (
        !e.target.classList.contains("option") &&
        !e.target.classList.contains("box") &&
        !e.target.classList.contains("value") &&
        !e.target.classList.contains("select-icon")
      ) {
        document.querySelectorAll(".select-mcmp").forEach(function (select) {
          if (select.querySelector("ul").classList.contains("expanded")) {
            select.querySelector(".box").click();
          }
        });
      }
    });
    if (this.$store.state.whitelabel.apiKey) {
      this.isTDP =
        this.$store.state.whitelabel.apiKey == process.env.VUE_APP_EMBED_KEY;
      this.changePartnerName();
    }
    await this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceSize);
  },
  methods: {
    async init() {
      this.verifyPremiumChat();
      this.verifyPreferredLanguage();
      this.verifyIfDesktop();
      this.verifyLogged();
      this.loadBasicData();
      await this.$apollo.provider.defaultClient.hydrated();
      this.hydrated = true;
    },
    verifyPremiumChat() {
      // Add safety checks for user and store state
      if (!this.$store?.state?.user?.isPro || this.isEmbedded) return;
      
      try {
        let freshChatScript = document.createElement("script");
        freshChatScript.setAttribute("src", "//fw-cdn.com/8252205/3311251.js");
        freshChatScript.setAttribute("chat", "true");
        document.head.appendChild(freshChatScript);
        
        // Guard against undefined properties
        if (window.fcWidget && this.$store.state.user) {
          window.fcWidget.user.setFirstName(this.$store.state.user.firstName || '');
          window.fcWidget.user.setEmail(this.$store.state.user.email || '');
          if (this.$store.state.user.id) {
            window.fcWidget.setExternalId(this.$store.state.user.id);
          }
        }
      } catch (error) {
        //eslint-disable-next-line no-console
        console.warn('Error initializing chat:', error);
      }
    },
    verifyPreferredLanguage() {
      if (this.$store.state.preferredLanguage !== "")
        this.$root.$i18n.locale = this.$store.state.preferredLanguage;
    },
    verifyIfDesktop() {
      if (this.$route.name === "sync-authorization") this.desktop = true;
      else this.desktop = screen.width >= 760;
    },
    verifyLogged() {
      this.logged = this.$store.state.token !== "";
      if (this.logged && ["login", "embed"].includes(this.$route.name))
        this.$router.push("/dashboard");
    },
    ...mapActions(["updateAppThemes"]),
    ...mapMutations([
      "setMarkets",
      "setIsPro",
      "setCurrentTheme",
      "setWhitelabelUtils",
    ]),
    loadBasicData() {
      axios.get(`${this.$store.state.backend}/markets`).then((response) => {
        //this.setMarkets(response.data.map(a => a.name));
        this.setMarkets(response.data);
      });
      if (this.$store.state.token !== "") {
        axios
          .get(`${this.$store.state.backend}/ext/user-details/user/pro`, {
            headers: { Authorization: this.$store.state.token },
          })
          .then((response) => {
            if (response.status < 400 && response.data) {
              this.setIsPro(true);
            }
          });
      }
    },
    async setupAppThemes() {
      let embedKey = process.env.VUE_APP_EMBED_KEY;
      if (embedKey) {
        await WhitelabelRepository.getWhitelabelByApiKey(embedKey)
          .then((res) => {
            // eslint-disable-next-line no-console
            console.log(res);
            if (res.data !== null) {
              // Saves white-labeled data in the store
              let utils = {
                partner: res.data.whitelabel.partner,
                embedKey: embedKey,
                features: res.data.features,
                platform: res.data.whitelabel.platform,
                isInvestorPasswordRequired:
                  res.data.whitelabel.investorPasswordRequired,
              };

              let appthemes = { light: {}, dark: {} };
              res.data.partnerBrandThemes.map((obj) => {
                let type = obj.type.toLowerCase();
                for (const [key, value] of Object.entries(obj)) {
                  if (key != "id" && key != "type") {
                    appthemes[type][key] = `#${value}`;
                  }
                }
              });

              this.updateAppThemes(appthemes);
              this.setWhitelabelUtils(utils);
            }
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      }
    },
    changePartnerName() {
      //till pages loads all texts
      let self = this;
      setTimeout(function () {
        const partnerName = self.$store.state.whitelabel.partner.fullName
          ? self.$store.state.whitelabel.partner.fullName
          : "";
        document.title = partnerName;
        function replaceTextNodes(node) {
          node.childNodes.forEach(function (el) {
            if (el.nodeType === 3) {
              el.nodeValue = el.nodeValue.replace("Swiset", partnerName);
            } else {
              replaceTextNodes(el);
            }
          });
        }
        replaceTextNodes(document.body)
      }, 1000);
    },
    checkDeviceSize() {
      const width = window.innerWidth;
      this.deviceSize = {
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1264,
        isDesktop: width >= 1264
      };
    }
  },
};
</script>



<style lang="scss">
@import "./styles/global";
@import "./styles/buttons";
@import "global";

@font-face {
  font-family: "Product Sans";
  font-style: normal;
  font-weight: normal;
  src: url("./assets/fonts/ProductSans-Regular.woff") format("woff");
}

@font-face {
  font-family: "Product Sans";
  font-style: normal;
  font-weight: bold;
  src: url("./assets/fonts/ProductSans-Bold.woff") format("woff");
}

@font-face {
  font-family: "Avenir";
  font-style: normal;
  font-weight: normal;
  src: url("./assets/fonts/Avenir-Book.woff") format("woff");
}

.v-input--radio-group {
  .v-radio {
    margin-bottom: 16px;

    // Remove default Vuetify hover effects
    .v-input--selection-controls__ripple {
      display: none !important;
    }

    .v-input--selection-controls__input {
      .v-icon {
        display: none; // Hide default radio icon
      }

      &::before {
        content: '';
        width: 20px;
        height: 20px;
        border: 2px solid #9A9A9A;
        border-radius: 50%;
        position: absolute;
        transition: all 0.3s ease;
      }

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        background-color: white;
        border-radius: 50%;
        position: absolute;
        left: 6px;
        top: 6px;
        transform: scale(0);
        transition: transform 0.2s ease;
      }

      &:hover::before {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
        transform: translateY(-1px);
        transition: all 0.3s ease;
      }
    }

    &.v-item--active {
      .v-input--selection-controls__input {
        &::before {
          border-color: var(--v-mainGreen-base);
          background-color: var(--v-mainGreen-base);
        }

        &::after {
          transform: scale(1);
        }
      }
    }

    &.v-item--disabled {
      .v-input--selection-controls__input {
        &::before {
          border-color: #E0E0E0;
          background-color: #F5F5F5;
        }

        &:hover::before {
          box-shadow: none;
        }
      }
    }
  }
}

.theme--dark.v-card {
  color: #ffffff;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9a9a9a;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#powered-by-fixed {
  margin-top: -100px;
  /*same as height*/
  margin-bottom: 10px;
  /*to avoid going under the bottom:20px we want*/
  position: fixed;
  left: 20px;
  top: calc(100vh - 10px);
}

h4 {
  color: var(--v-darkGrey-base);
  font: 16px $title-font;
}

p {
  color: var(--v-mainBlack-base);
}

.green-button {
  border: 1px solid $primary-color !important;
  background-color: $primary-color !important;
  color: $black-color !important;
}

.green-button:hover {
  border: 2px solid $primary-color !important;
  background-color: $primary-color !important;
  color: $black-color !important;

  border-radius: 7px !important;
  font: 16px $title-font;
  padding: 1% 3%;
}

button {
  border-radius: 7px;
  padding: 1% 3%;
}

.submit-button {
  padding: 1.5% 5% !important;
  color: $black-color !important;
  border: 0px solid #247851 !important;
  border-radius: 7px !important;
  background-color: $calm-green !important;
  box-shadow: 1px 1px 10px rgba(36, 120, 81, 0.25);
}

.submit-button:hover {
  color: $calm-green !important;
  border: 0px solid #247851 !important;
}

.back-button {
  padding: 1.5% 5% !important;
  color: $black-color !important;
  border: 0px solid white !important;
  border-radius: 7px !important;
  background-color: #dcdcdc !important;
  box-shadow: 1px 1px 10px rgba(36, 120, 81, 0.25);
}

.back-button:hover {
  color: $black-color !important;
  border: 0px solid white !important;
  background-color: #dcdcdc !important;
}

.button-giant {
  padding: 3% 7% !important;
}

table.v-table thead th {
  font-size: 17px !important;
}

table.v-table tbody td {
  font-size: 16px !important;
}

.section-card {
  background-color: rgba(144, 146, 156, 0) !important;
}

.overall-card-collapsed {
  height: 100px;
  border-radius: 20px !important;

  .head {
    color: $black-color;
    font-size: 22px;
  }

  .content {
    color: $text-color;
    margin-bottom: 0;
  }
}

.adding-card-collapsed {
  height: 100px;
  border: 2px dashed #6c7079 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: var(--v-lightGrey-base);
    color: var(--v-darkGrey-base);
  }
}

.see-more-card-collapsed {
  height: 100px;
  border: 1px solid #d0d0d0 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: var(--v-lightGrey-base);
    color: var(--v-darkGrey-base);
  }
}

.ad-card-collapsed {
  height: 100px !important;
  border: 3px solid $blue-color !important;
  border-radius: 20px !important;
  background-color: #ffffff !important;

  .badge {
    font-size: 12px;
    color: var(--v-mainWhite-base);
    background-color: $blue-color;
    margin-right: -5px;
    padding: 3px 5px 6px;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
  }

  .ad-title {
    font-size: 17px !important;
    color: $black-color !important;
  }

  .ad-description {
    font-size: 14px;
    color: $subtitle-color;
  }

  .ad-btn {
    background-color: $black-color !important;
    color: $white-color !important;
  }

  .ad-btn:hover {
    background-color: $blue-color !important;
    border-color: $blue-color !important;
  }
}

.overall-card {
  height: 160px !important;
  border-radius: 20px !important;

  .head {
    color: $black-color;
    font-size: 23px;
  }

  .content {
    color: $text-color;
  }
}

.adding-card {
  height: 160px !important;
  border: 2px dashed #6c7079 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6c7079;
  }
}

.see-more-card {
  height: 160px !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6c7079;
  }
}

.icon {
  color: #929292 !important;
  border: none !important;
}

.icon:hover {
  color: #929292 !important;
  background-color: rgba(85, 85, 85, 0) !important;
  border: none !important;
}

.help-button {
  display: block;
  border: none;
  position: fixed;
  top: auto;
  bottom: 90% !important;
  right: 0;
  width: 150px;
  height: 350px;
  transform: translateY(50%) rotate(-90deg) !important;
  opacity: 1;
  background: none transparent !important;
  margin: 0 !important;
  padding: 0 !important;
  max-height: 100vh;
  max-width: 100vw;
  transition: none 0s ease 0s !important;
  visibility: visible;
  z-index: 99999 !important;
}

.help-button-for-pro {
  position: fixed;
  right: 0;
  bottom: 50%;
  transform: rotate(-90deg);
  margin: 0 -70px 0 0;
}

.help-button-no-pro {
  position: fixed;
  right: 0;
  bottom: 50%;
  transform: rotate(-90deg);
  margin: 0 -70px 0 0;
}

/* Mobile Help Button */
.mobile-help-btn {
  position: fixed !important;
  bottom: 80px !important; /* Keep above bottom navigation */
  right: 16px !important;
  z-index: 999;
  background-color: var(--v-mainGreen-base) !important;
  color: var(--v-fullWhite-base) !important;
}

.mobile-language-selector {
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 999;
}

.row {
  margin-top: 0;
  margin-bottom: 0;
  margin: 0;
}

.row+.row {
  margin-top: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-input--radio-group {
    .v-radio {
      margin-bottom: 16px;

      // Remove default Vuetify hover effects
      .v-input--selection-controls__ripple {
        display: none !important;
      }

      .v-input--selection-controls__input {
        .v-icon {
          display: none; // Hide default radio icon
        }

        &::before {
          content: '';
          width: 20px;
          height: 20px;
          border: 2px solid #9A9A9A;
          border-radius: 50%;
          position: absolute;
          transition: all 0.3s ease;
        }

        &::after {
          content: '';
          width: 8px;
          height: 8px;
          background-color: white;
          border-radius: 50%;
          position: absolute;
          left: 6px;
          top: 6px;
          transform: scale(0);
          transition: transform 0.2s ease;
        }

        &:hover::before {
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
          transform: translateY(-1px);
          transition: all 0.3s ease;
        }
      }

      &.v-item--active {
        .v-input--selection-controls__input {
          &::before {
            border-color: var(--v-mainGreen-base);
            background-color: var(--v-mainGreen-base);
          }

          &::after {
            transform: scale(1);
          }
        }
      }

      &.v-item--disabled {
        .v-input--selection-controls__input {
          &::before {
            border-color: #E0E0E0;
            background-color: #F5F5F5;
          }

          &:hover::before {
            box-shadow: none;
          }
        }
      }
    }
  }
</style>
